const MEDIAS_BASE_URL = "https://cleristonmp.github.io/portfolio/assets/medias";

export default MEDIAS_BASE_URL;
